<template>
    <div class="xczx">
        <img src="./img/banner.png" alt="" class="bg">
        <div class="content">
            <div class="guide_text">
                多年来，蓝海密剑主办方——东航期货，围绕国家“实施乡村振兴”战略总要求，积极响应期货行业服务实体经济号召，协同母公司东航金控，在云南沧源、双江等地，践行产业帮扶、教育帮扶、消费帮扶等，以金融力量，为当地乡村振兴打造高速引擎。
            </div>
            <div class="introduce_text">
                自2019年起，公司在沧源地区持续实施“保险+期货”项目，累计引入交易所资金836余万元，赔付近677万元，惠及农户8357户。其中，天然橡胶项目持续进行，并成功试点实施了白糖和生猪“保险+期货”项目，有效保障了农户的收益。2024年，公司带动版块内兄弟公司东航保理共同出资30万元，在班老乡实施天然橡胶“保险+期货”项目，助力当地橡胶产业发展。
            </div>
            <p class="introduce_text">
                在教育帮扶方面，东航期货积极参与“爱在东航 大山梦想”公益活动，累计捐款数十万元，用于改善学校设施和教学条件。例如，修建教师学生宿舍、添置教学一体机和速印机、修建学生浴室等，有效提升了当地学校的教学水平。
            </p>
            <p class="introduce_text">
                在产业帮扶方面，公司捐赠资金试点百香果种植产业，取得了丰收成果。2024年，公司继续扩大百香果种植面积，助力当地产业发展。同时，公司还积极引入期货界力量参与帮扶活动，共同助力乡村振兴。
            </p>
            <p class="introduce_text">
                此外，东航期货还注重党建带团建工作，将“党建引领、团建赋能”融入乡村振兴工作，充分发挥团组织作用。通过组织开展义卖活动等方式筹集爱心捐款，为当地学校捐赠体育器材和训练服等物资，用爱帮扶助成长。
            </p>
            <div class="swiper">
                <mt-swipe class="my-swipe" indicator-color="white"  :auto="3000" >
                    <mt-swipe-item>
                        <img id="img" src="./img/swipe_01.png" alt="">
                    </mt-swipe-item>
                    <mt-swipe-item>
                        <img  id="img" src="./img/swipe_02.png" alt="">
                    </mt-swipe-item>
                    <mt-swipe-item>
                        <img   id="img" src="./img/swipe_03.png" alt="">
                    </mt-swipe-item>
                    <mt-swipe-item>
                        <img  id="img" src="./img/swipe_04.png" alt="">
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="swiper_text">
                < 左右滑动查看更多 >
            </div>
            <div class="title">
                <img src="./img/title.png" alt="">
            </div>
            <div class="callfor_text">亲爱的期货行业同仁及社会各界爱心人士，</div>
            <div class="callfor_text text_indent">
                在这个充满希望与挑战的新时代，我们诚挚地向您发出邀请，成为“蓝海密剑乡村振兴事业伙伴”！
            </div>
            <div class="callfor_text text_indent">
                让我们携手并进，将目光投向那片孕育无限可能的乡村大地。通过产业帮扶，我们赋能农村，激活经济新活力；通过教育帮扶，我们点亮智慧之光，培育未来之星；通过消费帮扶，我们搭建桥梁，让每一份支持都化作乡村发展的动力源泉。
            </div>
            <div class="callfor_text text_indent">
                您的每一分参与，都是对乡村振兴最真挚的承诺；您的每一步脚印，都将深刻在助力乡村蜕变的征途上。不论您是期货界的精英，还是心系家国的热心公民，这里都有您发光发热的舞台。
            </div>
            <div class="callfor_text text_indent">
                加入我们，用实际行动诠释责任与担当，共同书写乡村振兴的壮丽诗篇。让我们并肩作战，在希望的田野上播种梦想，收获幸福，共创一个更加繁荣、和谐的美好未来！
            </div>
            <div class="callfor_text text_indent">
                立即响应，成为“蓝海密剑乡村振兴事业伙伴”，一起开启这段意义非凡的旅程吧！
            </div>

            <div class="encourage_box pd15">
                <van-button class='openIframe_encourage'  @click="encourage" >
                        觉得这个活动不错，鼓励一下
                </van-button>
                <div>
                        <van-icon name="good-job" />
                        <div class="number">
                        {{ encourageNum }}
                        </div> 
                </div>
            </div>

            <div class="title_text">
                乡村振兴 以期前行
            </div>
            <div class="nav_text">
                云南特色产品公益集市
            </div>
            <div class="qcard">
                <div>
                    <div @click="qcord"><img src="./img/dh.png" alt=""></div>
                    <div>请直接点击上方二维码<br />参与消费帮扶</div>
                </div>
                <div>
                    <div @click="previewImg"><img src="./img/miniProgram.jpg" alt=""></div>
                    <div>请用微信"扫一扫"上方二维码<br />参与消费帮扶</div>
                </div>
            </div>

            <div class="project_text">
                组委会计划助力帮扶以下项目：
            </div>

            <div class="ask_text fupin_text">
                班老乡九年一贯制中心校——
            </div>

            <div class="ask_text fupin_text">
                悬浮地板篮球场及跑道项目、采购学生课桌项目、会议室桌椅采购项目、台式机电脑采购项目等，助力当地小学改善教学条件，助力当地教育发展。
            </div>

            <div class="ask_text money_text">
                具体支持项目及金额以实际为准。
            </div>
            <div class="fupin_text pd15">
                若您想进一步助力，请留下联系方式，组委会将会联系您具体事宜。
            </div>
            <div class='openIframe_bx'>
                <van-button class='openIframe'  @click="openIframe">我要进一步助力</van-button>
            </div>
        </div>
        <van-overlay :show="showAlert" @click="showAlert = false">
            <div class="wrapper">
              <img src="./img/miniProgram.jpg" style="width: 300px; height: 300px;" alt="">
            </div>
        </van-overlay>
    </div>
</template>

  <script>
    /* eslint-disable */
    import { Swipe, SwipeItem } from 'mint-ui';
    import SERVICEPUBLICAPI from '@/common/ajax/API/SERVICEPUBLICAPI'
    export default {
      name: 'xczx',
      data () {
        return {
            encourageNum: 100,
            showAlert: false,
            alertMessage: '',
        }
      },
      components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
      },
      created() {
          this.getLikesCount()
      },
      methods:{
        //   点赞数量
        async getLikesCount() {
            const res = await SERVICEPUBLICAPI.getLikesCount()
            this.encourageNum = res.data.count ? res.data.count : 100
        },
        //   点赞
        async encourage() {
            const res = await SERVICEPUBLICAPI.likesCount()
            if(res.resultStatus === '0') {
                this.encourageNum += 1
            }
        },
        qcord() {
            window.location.href = 'https://shopping.ceair.com/static/actTmpl/activityTemplate-PC.html?pageCode=MALL_M55215_2020091801092815&iad=app_43_258_a7_7758'
        },
        openIframe(){
            window.location.href = '/Service/lhmj/ruralPlaningResearch2'
            //  this.$router.push('wjdc')
        }, 
        // 预览图片
        previewImg() {
            this.showAlert = true 
        }
      }
    }
  </script>
  <style scoped>
    .openIframe{
        width: 80vw !important;
        height: 50px;
        padding: 20px 0px;
        text-align: center;
        background-color: #e39d5c;
        border:none!important;
        border-radius: 6px;
        font-size: 20px;
        color: #fff8e6;
    }

    .encourage_box {
        height: 50px;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }
    
    .openIframe_encourage {
        width: 70vw !important;
        height: 50px;
        text-align: center;
        background-color: #e39d5c;
        border:none!important;
        border-radius: 6px;
        font-size: 14px;
        color: #fff8e6;
    }
    .openIframe_bx{
        text-align: center;
        padding: 20px 0px;
    }
    .xczx {
        width: 100vw;
        overflow: auto;
        font-family: "思源黑体";
        color: #510703;
        position: relative;
        padding-bottom: 20px;
        background: url('./img/bg.png');
        background-repeat: no-repeat;
        background-size: cover;
    }
    .bg{
        display: block;
        width: 100%;
    }
    .content {
        width: 90%;
        margin: 0 auto;
        background-color: #fff8e6;
	    border-radius: 25px;
        font-size: 18px;
        color: #510703;
        padding-bottom: 20px;
    }
    .guide_text {
        text-indent: 2em;
        padding: 30px 20px 20px 20px;
    }
    .introduce_text {
        text-indent: 2em;
        padding: 0px 20px;
        font-size: 18px;
    }
    .swiper {
        padding: 0px 20px;
        height: 200px;
    }
    .swiper img {
        width: 100%;
        height: 200px;
        border-radius: 5px;
    }
    .swiper_text {
        font-size: 15px;
        line-height: 25px;
        color: #e39d5c;
        text-align: center;
        padding: 5px 20px 0px 0px;
    }
    .title {
        display: flex;
        justify-content: center;
        margin: 20px 0px;
    }
    .title img {
        width: 80%;
        object-fit: contain;
    }
    .ask_text {
        font-size: 18px;
        text-indent: 1em;
        padding: 0px 20px;
    }
    .van-radio-group {
        height: 50px;
        padding-left: 15px;
    }
    .icon {
        font-size: 30px;
        color: #cc0000;
    }
    .van-icon {
        font-size: 20px;
        padding-left: 10px;
        color: #cc0000;
    }
    .number {
        font-size: 16px;
        font-weight: 700;
        margin-top: -5px;
        margin-left: 5px;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    .alertMessage {
      width: 270px;
      padding: 15px 10px;
      text-align: center;
      background-color: #fff;
      color: #cc0000;
      border-radius: 5px;
    }
    .end {
        text-align: center;
        font-size: 25px;
        margin-top: 10%;
    }

    .callfor_text {
        padding: 10px;
        letter-spacing: -0.5px;
    }
    .text_indent {
        text-indent: 2em;
    }

    .title_text {
        text-align: center;
        padding: 20px 0px 10px 0px;
        font-size: 24px;
        color: #cc0000;
        font-weight: 700;
    }
    .nav_text {
        text-align: center;
        font-size: 20px;
        color: #cc0000;
        font-weight: 700;
    }

    .qcard {
        display: flex;
        padding: 40px 30px 20px 30px;
        justify-content: center;
        text-align: center;
        font-size: 11px;
    }
    .qcard div {
        flex: 1;
    }
    .qcard div:nth-child(1) {
        margin-right: 5px;
    }

    .qcard img {
        width: 100px;
        height: 100px;
        margin-bottom: 15px;
    }

    .project_text {
        font-size: 20px;
        color: #cc0000;
        font-weight: 700;
        padding: 15px;
        text-indent: 1em;
    }

    .fupin_text {
        font-size: 18px;
        padding-bottom: 15px;
        text-indent: 1em;
    }

    .money_text {
        color: red;
        font-weight: 700;
    }
    .pd15 {
        padding: 15px;
    }

  </style>



// WEBPACK FOOTER //
// index.vue?e12774e6